import { Component } from "react";
import { RefreshCw } from "lucide-react";

/**
 * Catches render errors in a subtree (e.g. a single admin tab) and shows a
 * friendly retry card instead of blanking the whole screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="panel p-10 text-center" data-testid="error-boundary">
          <div className="overline mb-3">// SOMETHING SLIPPED</div>
          <p className="text-textMuted mb-6">This section hit a snag. Reload it without losing your place.</p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="btn-ghost inline-flex"
          >
            <RefreshCw className="w-4 h-4" /> Reload section
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
